<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Adicionar procedimento"
        v-if="loaded"
    >
        <rkm-form>
            <rkm-row>
                <rkm-col cols="1">
                    <rkm-form-input
                        label="Quantidade"
                        v-model="model.quantidade"
                        :validations="validations.quantidade"
                        number
                    />
                </rkm-col>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        label="Procedimento"
                        :repository="repositories.procedimento"
                        :request-query-string-params="autocompleteRequestParams.procedimento.queryString"
                        :search-fields="fields.autocomplete.procedimento"
                        :text-field="p => `${this.formatProcedimento(p.codigo)} - ${p.nome}`"
                        name="Procedimento"
                        v-model="model.procedimento"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="model.searchByApelido">
                                    <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                    <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel"> Fechar </rkm-button>

            <rkm-button
                :disabled="isDisabled"
                @click="saveProcedimento"
                color="primary"
            >
                Incluir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import procedimento from '@/enums/atencao-basica/atendimento-odontologico/procedimento'

import { repository, stringCase, object, formats } from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                quantidade: {
                    max_value: this.getMaxValue()
                }
            }
        },
        isDisabled() {
            if(this.model.procedimentos.length + Object.entries(this.model.procedimentosQuantidade).filter(p => {
                return p[1] != ''
            }).length >= 20) {
                return true
            }
            if(this.model.procedimento) {
                if(this.model.procedimentos.find(p => p.codigo == this.model.procedimento.codigo)) {
                    return true
                }
                if(this.model.quantidade > this.getMaxValue()) {
                    return true
                }
            }
            return false
        },
        autocompleteRequestParams() {
            return {
                procedimento: {
                    queryString: {
                        search_by_apelido: this.model.searchByApelido,
                        paciente_id: this.model.cidadao
                            ? this.model.cidadao.pacienteId
                            : null,
                        cbo: this.model.cadastro
                            ? this.model.cadastro.ocupacaoId
                            : null,
                        only_with_cbo: true,
                        atendimento_odontologico: true,
                        where: {
                            'codigo': [
                                this.enums.procedimento.APARELHO_FIXO_BILATERAL_PARA_FECHAMENTO_DE_DIASTEMA,
                                this.enums.procedimento.APARELHO_ORTODONTICO_FIXO,
                                this.enums.procedimento.APARELHO_ORTOPEDICO_E_ORTODONTICO_REMOVIVEL,
                                this.enums.procedimento.APARELHO_ORTOPEDICO_FIXO,
                                this.enums.procedimento.APARELHO_PARA_BLOQUEIO_MAXILO_MANDIBULAR,
                                this.enums.procedimento.COROA_DE_ACO_E_POLICARBOXILATO,
                                this.enums.procedimento.COROA_PROVISORIA,
                                this.enums.procedimento.MANTENEDOR_DE_ESPAÇO,
                                this.enums.procedimento.PLACA_OCLUSAL,
                                this.enums.procedimento.PLANO_INCLINADO,
                                this.enums.procedimento.PROTESE_CORONARIAS,
                                this.enums.procedimento.PROTESE_DENTARIA_SOBRE_IMPLANTE,
                                this.enums.procedimento.PROTESE_PARCIAL_MANDIBULAR_REMOVIVEL,
                                this.enums.procedimento.PROTESE_PARCIAL_MAXILAR_REMOVIVEL,
                                this.enums.procedimento.PROTESE_TEMPORARIA,
                                this.enums.procedimento.PROTESE_TOTAL_MANDIBULAR,
                                this.enums.procedimento.PROTESE_TOTAL_MAXILAR,
                            ]
                        },
                        where_not:{
                            'codigo': [
                                this.enums.procedimento.ACESSO_POLPA_DENTARIA,
                                this.enums.procedimento.ADAPTACAO_PROTESE_DENTARIA,
                                this.enums.procedimento.APLICACAO_CARIOSTATICO,
                                this.enums.procedimento.APLICACAO_SELANTE,
                                this.enums.procedimento.APLICACAO_TOPICA_FLUOR,
                                this.enums.procedimento.CAPEAMENTO_PULPAR,
                                this.enums.procedimento.CIMENTACAO_PROTESE_DENTARIA,
                                this.enums.procedimento.CURATIVO_DEMORA,
                                this.enums.procedimento.DRENAGEM_ABSCESSO,
                                this.enums.procedimento.EVIDENCIACAO_PLACA_BACTERIANA,
                                this.enums.procedimento.EXODONTIA_DENTE_DECIDUO,
                                this.enums.procedimento.EXODONTIA_DENTE_PERMANENTE,
                                this.enums.procedimento.INSTALACAO_PROTESE_DENTARIA,
                                this.enums.procedimento.MOLDAGEM_PROTESE_DENTARIA,
                                this.enums.procedimento.ORIENTACAO_HIGIENE_BUCAL,
                                this.enums.procedimento.REMOCAO_PLACA_BACTERIANA,
                                this.enums.procedimento.PULPOTOMIA_DENTARIA,
                                this.enums.procedimento.RASPAGEM_SUPRAGENGIVAIS,
                                this.enums.procedimento.RASPAGEM_SUBGENGIVAIS,
                                this.enums.procedimento.RESTAURACAO_DENTE_PERMANENTE_ANTERIOR,
                                this.enums.procedimento.SELAMENTO_PROVISORIO_CAVIDADE_DENTARIA,
                                this.enums.procedimento.TRATAMENTO_ALVEOLITE,
                                this.enums.procedimento.ULOTOMIA_ULECTOMIA,
                                this.enums.procedimento.ESCUTA_INICIAL,
                            ]
                        },
                    },
                },
            }
        },
        fields() {
            return {
                autocomplete: {
                    procedimento: this.model.searchByApelido
                        ? [
                              {
                                  key: "parametrizacao_procedimento.apelido",
                                  searchable: true,
                              },
                          ]
                        : [
                              { key: "nome", searchable: true },
                              { key: "codigo", searchable: true },
                          ],
                },
            };
        },
    },
    data: () => ({
        enums: {
            procedimento
        }
    }),
    methods: {
        open() {
            this.resetForm()
            this.$refs.Modal.show();
        },
        getMaxValue() {
            if(this.model.procedimento) {
                if([
                    this.enums.procedimento.RADIOGRAFIA_OCLUSAL,
                    this.enums.procedimento.COLOCACAO_PLACA_MORDIDA,
                    this.enums.procedimento.MANUTENCAOO_CONSERTO_APARELHO,
                    this.enums.procedimento.CONTENCAOO_DENTES_SPLINTAGEM,
                    this.enums.procedimento.REDUCAO_LUXACAOO_TEMPORO_MANDIBULAR,
                    this.enums.procedimento.RETIRADA_MATERIAL_SÍNTESE,
                    this.enums.procedimento.EXERESE_CISTO,
                    this.enums.procedimento.TRATAMENTO_CIRURGICO_FISTULA,
                    this.enums.procedimento.CORRECAO_BRIDAS_MUSCULARES,
                    this.enums.procedimento.CORRECAO_IRREGULARIDADES_REBORDO_ALVEOLAR,
                    this.enums.procedimento.REMOCAO_TORUS_EXOSTOSES,
                    this.enums.procedimento.MANTENEDOR_ESPAÇO,
                    this.enums.procedimento.PLACA_OCLUSAL,
                    this.enums.procedimento.PLANO_INCLINADO,
                    this.enums.procedimento.PROTESE_PARCIAL_MANDIBULAR_REMOVIVEL,
                    this.enums.procedimento.PROTESE_PARCIAL_MAXILAR_REMOVIVEL,
                    this.enums.procedimento.PROTESE_TEMPORARIA,
                    this.enums.procedimento.PROTESE_TOTAL_MANDIBULAR,
                    this.enums.procedimento.PROTESE_TOTAL_MAXILAR,
                    this.enums.procedimento.MOLDAGEM_DENTO_GENGIVAL,

                ].includes(this.model.procedimento.codigo)) {
                    return 2
                }
                if([
                    this.enums.procedimento.APLICACAO_CARIOSTATICO,
                    this.enums.procedimento.APLICACAO_SELANTE,
                    this.enums.procedimento.SELAMENTO_PROVISORIO_CAVIDADE_DENTARIA,
                    this.enums.procedimento.RADIOGRAFIA_INTERPROXIMAL,
                    this.enums.procedimento.RADIOGRAFIA_PERIAPICAL,
                    this.enums.procedimento.CAPEAMENTO_PULPAR,
                    this.enums.procedimento.RESTAURACAO_DENTE_PERMANENTE_ANTERIOR,
                    this.enums.procedimento.TRATAMENTO_INICIAL_DENTE_TRAUMATIZADO,
                    this.enums.procedimento.TRATAMENTO_RESTAURADOR_ATRAUMATICO,
                    this.enums.procedimento.RESTAURACAO_DENTEDECIDUO_POSTERIOR_RESINA_COMPOSTA,
                    this.enums.procedimento.RESTAURACAO_DENTE_DECIDUO_POSTERIOR_AMALGAMA,
                    this.enums.procedimento.RESTAURACAO_DENTE_DECIDUO_POSTERIOR_IONOMERO_VIDRO,
                    this.enums.procedimento.RESTAURACAO_DENTE_DECIDUO_ANTERIOR_RESINA_COMPOSTA,
                    this.enums.procedimento.RESTAURACAO_DENTE_PERMANENTE_POSTERIOR_RESINA_COMPOSTA,
                    this.enums.procedimento.RESTAURACAO_DENTE_PERMANENTE_POSTERIOR_AMALGAMA,
                    this.enums.procedimento.ACESSO_POLPA_DENTARIA,
                    this.enums.procedimento.CURATIVO_DEMORA,
                    this.enums.procedimento.OBTURACAO_DENTE_DECIDUO,
                    this.enums.procedimento.OBTURACAO_DENTE_PERMANENTE_BIRRADICULAR,
                    this.enums.procedimento.OBTURACAO_DENTE_PERMANENTE_RAIZES,
                    this.enums.procedimento.OBTURACAO_DENTE_PERMANENTE_UNIRRADICULAR,
                    this.enums.procedimento.PULPOTOMIA_DENTARIA,
                    this.enums.procedimento.RETRATAMENTO_ENDODÔNTICO_DENTE_PERMANENTE_BIRADICULAR,
                    this.enums.procedimento.RETRATAMENTO_ENDODÔNTICO_DENTE_PERMANENTE_RAIZES,
                    this.enums.procedimento.RETRATAMENTO_ENDODÔNTICO_DENTE_PERMANENTE_UNIRADICULAR,
                    this.enums.procedimento.SELAMENTO_PERFURACAO_RADICULAR,
                    this.enums.procedimento.MOLDAGEM_PROTESE_DENTARIA,
                    this.enums.procedimento.REEMBASAMENTO_CONSERTO_PROTESE_DENTARIA,
                    this.enums.procedimento.CIMENTACAO_PROTESE_DENTARIA,
                    this.enums.procedimento.ADAPTACAO_PROTESE_DENTARIA,
                    this.enums.procedimento.AJUSTE_OCLUSAL,
                    this.enums.procedimento.INSTALACAO_PROTESE_DENTARIA,
                    this.enums.procedimento.APICECTOMIA,
                    this.enums.procedimento.CURETAGEM_PERIAPICAL,
                    this.enums.procedimento.EXODONTIA_DENTE_DECIDUO,
                    this.enums.procedimento.EXODONTIA_DENTE_PERMANENTE,
                    this.enums.procedimento.ODONTOSECCAO_RADILECTOMIA_TUNELIZACAO,
                    this.enums.procedimento.REIMPLANTE_TRANSPLANTE_DENTAL,
                    this.enums.procedimento.REMOCAO_DENTE_RETIDO,
                    this.enums.procedimento.TRATAMENTO_CIRURGICO_TRACIONAMENTO_DENTAL,
                    this.enums.procedimento.TRATAMENTO_ALVEOLITE,
                    this.enums.procedimento.ULOTOMIA_ULECTOMIA,
                    this.enums.procedimento.COROA_PROVISORIA,
                    this.enums.procedimento.PROTESE_CORONARIAS,

                ].includes(this.model.procedimento.codigo)) {
                    return 32
                }
                if([
                    this.enums.procedimento.RASPAGEM_SUBGENGIVAIS,
                    this.enums.procedimento.RASPAGEM_SUPRAGENGIVAIS,
                    this.enums.procedimento.APROFUNDAMENTO_VESTIBULO_ORAL,
                    this.enums.procedimento.GENGIVECTOMIA,
                    this.enums.procedimento.GENGIVOPLASTIA,
                    this.enums.procedimento.TRATAMENTO_CIRURGICO_PERIODONTAL,
                    this.enums.procedimento.RASPAGEM_CORONO_RADICULAR,
                    this.enums.procedimento.EXODONTIA_MULTIPLA_ALVEOLOPLASTIA,
                ].includes(this.model.procedimento.codigo)) {
                    return 6
                }
            }
            return 1
        },
        saveProcedimento() {
            const param = {
                id: this.model.procedimento.id,
                nome: this.model.procedimento.nome,
                codigo: this.model.procedimento.codigo,
                quantidade: this.model.quantidade == '' ? '1' : this.model.quantidade,
                origem: 'atencaoBasica'
            };
            if (this.index) {
                this.$set(
                    this.model.procedimentos,
                    this.index,
                    this.clone(param)
                );
            } else {
                this.model.procedimentos.push(this.clone(param));
            }
            this.resetForm()
            this.$refs.Modal.hide()
        },
        resetForm() {
            this.model.procedimento = null
            this.model.quantidade = ''
        },
    },
    mixins: [ repository, stringCase, object, formats ],
    props: {
        model: { type: Object, required: false },
        form: { type: Object, required: false },
        loaded: { type: Boolean, required: false },
        repositories: { type: Object, required: false },
        procedimentos: { type: Object, required: false }
    },
};
</script>
